/**
 * Replaced Woocommerce's version of select2 with selectize for drag and drop support.
 */
import '../../node_modules/@selectize/selectize/dist/js/selectize.min.js';

jQuery( function() {
	const selectElements = document.querySelectorAll( '.qala-block-areas-select' );
	if ( selectElements ) {
		const selectElementsArray = [ ...selectElements ];
		selectElementsArray.forEach( selectElement => {
			jQuery( selectElement ).selectize( {
				plugins: [ 'drag_drop', 'remove_button' ],
				labelField: 'name',
				searchField: 'name',
			} );
		} );
	}
} );
